module.exports = __webpack_public_path__ + "static/media/logo_old.8e1c406f.png";